import React from 'react';

const TermsAdditional = () => (
  <div>
    <p>
      Last updated: <strong>March 15, 2018</strong>
    </p>
    <p>
      Your use of the MYSKP / MYTRACKER platform and Schwarzkopf Professional, a
      division of Henkel Corporation or one of its subsidiary or affiliated
      companies (collectively, “SKP”, “we”, “our” or “us”) website at
      http://myskp.com and the MYSKP Enterprise suite of applications
      (hereinafter collectively referred to as “MYSKP”) is subject to out{' '}
      <a
        href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank
      </a>
      ,{' '}
      <a
        href="https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank"
        style={{ textDecoration: 'underline' }}
        target="_blank"
        rel="noopener noreferrer"
      >
        https://www.henkel-northamerica.com/terms-of-use-na?view=content-blank
      </a>{' '}
      as well as by this Terms of Use and Privacy Supplement (“
      <strong>Additional Terms</strong>”).
    </p>
    <p>
      By installing, downloading or otherwise using MYSKP, you are deemed to
      have read and agreed to be bound by our Terms of Use and these Additional
      Terms and agree to our Privacy Policy. If you do not agree with all of
      these, you may not use MYSKP.
    </p>
    <ol style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Functions of MYSKP</strong>
        </p>
        <p>
          MYSKP is a suite of applications and website for the use of
          professional hair stylists, salons, and SKP sales representatives and
          distributors in the United States. It serves as a sales and marketing
          tool by helping to facilitate inventory management (on a sell through
          / sell out basis), re-ordering, and sales, by allowing stylists and
          salons to track their inventory, purchasing, and usage history, and
          can assist in developing advertising creative. It allows SKP, and SKP
          sales representatives and distributors, to review the sales, product,
          and salon information within their supply chain, for purposes
          including the management of their businesses and tools to analyze
          performance data and help maximize sales with visualized key business
          metrics. It also assists SKP with incentive program management, and
          managing and distributor sales consultant management.
        </p>
        <p>
          The MYSKP suite of applications includes, or may in the future
          include, the following features:
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>CLUBSKP</strong>
            </p>
            <p>
              A portal that allows eligible users to access their CLUBSKP
              account- a loyalty program that allows salons to redeem and track
              points from extracted sales data, in accordance with the Terms of
              the CLUB SKP Program. This portal is set up as an e-commerce
              system through which points may be redeemed at the rates set by
              SKP from time to time, and subject to the Terms of the CLUB SKP
              Program
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>PRINTCENTER</strong>
            </p>
            <p>
              An app where salons are able to customize materials and order
              Advertising Materials, including branded print collateral, as
              further described in section 3 below. Users can either directly
              order online with a 3rd party vendor for fulfillment or download
              material directly for their own use in accordance with these
              Additional Terms, and any specified term, usage limits or
              instructions that may be provided by SKP.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>FILEVAULT</strong>
            </p>
            <p>
              An online repository and file sharing of branded assets including
              images, marketing material and videos as determined by SKP from
              time to time. SKP may set limits on what users are permitted to
              access what assets. Subject to any such limits, all assets are
              organized in folders with the ability for users to create their
              own. Certain assets can be directly downloaded at various file
              size or application purposes. All materials in the file vault are
              “Advertising Materials” within the meaning of section 3 below, and
              may only be used in accordance with these Terms of Use, and any
              specified term, usage limits or instructions that may be provided
              by SKP.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>POE</strong>
            </p>
            <p>
              This is an app that is used by SKP to administer the distributor
              Sales Incentive program called “Profile of Excellence”, using
              information uploaded by the distributors using the ETL tool. SKP
              uses an ETL tool to extract all sales data from the Schwarzkopf
              ERP system and/or Distributor data. The app then automatically
              allocates incentive points and spiffs due to sales consultants, if
              any, and generates invoices. All stakeholders are able to track
              their progress as well as check their leader-board standing. SKP
              does not guarantee the accuracy of the leaderboard, or any point
              totals, and may adjust them at any time if an error is discovered.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>ADVISORNET</strong>
            </p>
            <p>
              A daily tracking and event scheduler app for education of internal
              technical advisor and technical supervisor stakeholders. These
              users may use this app to schedule, track and report their daily
              activities. It tracks calendar activity of SKP technical advisors
              and serves as a reimbursement site for costs associated with such
              technical advisors according to a built-in SKP approval process,
              and allows an automatic deployment of invoices for expense
              reimbursement, allowing SKP to track and reimburse SKP designated
              third parties, in a manner and such amounts as may have been
              approved by SKP. Detailed performance reporting helps all
              stakeholders to manage and improve the efficiency of their daily
              activity to increase ROI.
            </p>
          </li>
          <li style={{ marginBottom: '16px' }}>
            <p>
              <strong>MYTRACKER</strong>
            </p>
            <p>
              Allows the visual tracking by SKP of all data in MYSKP, which
              includes both sales and activities data. Distributors may only
              view their own data and that of their downstream sales
              consultants.
            </p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Accessing MYSKP and Account Security</strong>
        </p>
        <p>You are responsible for:</p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              Making all arrangements necessary for you to have access to MYSKP;
              and
            </p>
          </li>
          <li>
            <p>
              Ensuring that all persons who access MYSKP through your internet
              connection are aware of these Terms of Use and comply with them.
            </p>
          </li>
        </ul>
        <br />
        <p>
          To access MYSKP or some of the resources it offers, you may be asked
          to provide certain registration details or other information. It is a
          condition of your use of MYSKP that all the information you provide on
          MYSKP is correct, current and complete.
        </p>
        <p>
          To access MYSKP services you will be required to register on MYSKP.
          All registrations are subject to the acceptance of SKP, which may be
          withheld or denied in our sole and absolute discretion. SKP may in its
          discretion set (or reset) different levels of access to MYSKP for
          different users and/or accounts, which may alter the content,
          applications, features or functions such users and/or accounts may
          access on MYSKP. You agree to: (a) maintain the confidentiality of any
          passwords or other account identifiers which you choose or that are
          assigned to you as a result of any registration or account creation
          with MYSKP; and (b) be responsible for all activities that occur under
          such password or account. Further, you agree to immediately notify us
          of any unauthorized use of your password or account in the event that
          the confidentiality of your password or your account is compromised.
          Failure to comply with this paragraph may result in immediate
          termination of your account. We shall not be responsible or liable,
          directly or indirectly, in any way for any loss or damage of any kind
          incurred as a result of, or in connection with, your failure to comply
          with this section, or for any delay in shutting down your account
          after you have reported a breach of security to us. You also agree to
          ensure that you exit from your account at the end of each session. You
          should use particular caution when accessing your account from a
          public or shared computer so that others are not able to view or
          record your password or other personal information or business
          information.
        </p>
        <p>
          We have the right to disable any account, and/or any user name,
          password or other identifier, whether chosen by you or provided by us,
          at any time in our sole discretion including if, in our opinion, you
          have violated any provision of these Additional Terms, any other
          agreement you have with us, or we have a reasonable belief that your
          account has been compromised. From time to time, we may restrict
          access to some parts of MYSKP, or the entire MYSKP. These restrictions
          may apply to individual MYSKP accounts, to all MYSKP accounts or to
          any subset thereof.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>License To Certain Advertising Materials</strong>
        </p>
        <p>
          We grant you a limited, non-exclusive, personal, non-transferable,
          non-sub-licensable and revocable right and license to access, view and
          print any information and documentation made available on MYSKP, for
          your personal, non-commercial (other than as permitted in accordance
          with these Terms of Use), and informational use only to assist you in
          the access and use of MYSKP. Certain features of MYSKP may permit you
          to download SKP advertising templates and materials for use in the
          promotion of the availability of SKP products through your business (“
          <strong>Advertising Materials</strong>”). We grant you a limited,
          non-exclusive, personal, non-transferable, non-sub-licensable and
          revocable right and license to access, view, print and disseminate,
          within the United States only, Advertising Materials made available on
          MYSKP, for the sole purpose of promoting the availability of SKP
          products through your business. All usage of the Advertising Materials
          must: i) be to promote the sale of SKP products; ii) be done in a
          manner that does not damage or disparage any SKP logos or trade-marks;
          iii) be done in a manner that is not confusing to the public; iv)
          comply with any specified term, usage limits or instructions that may
          be provided by SKP. This licence includes the limited ability to edit
          the Advertising Materials to include information respecting your
          business as well as any offers or promotions you choose to make in
          respect of it (“<strong>Offers</strong>”), but not to edit or alter
          any SKP logos, trade-marks, graphic, or images, which may appear only
          as provided in the Advertising Materials. You, and not SKP, are
          responsible for any Offers you choose to make, and without limitation
          are responsible for ensuring their legal compliance.
        </p>
        <p>
          Certain Advertising Materials or other materials available on MYSKP
          may be subject to addition usage requirements, instructions,
          restrictions, or limitations that differ from the above licence. For
          example, this may include additional territorial limitations, and/or
          restricted usage periods. If you choose to use any Advertising
          Materials or other materials available on MYSKP, you must agree to and
          comply with any such requirements, instructions, restrictions, or
          limitations. You agree that you will cease use of any Advertising
          Materials or other materials available on MYSKP at the request of SKP.
        </p>
        <p>
          Except for the limited licenses and rights expressly granted to you in
          the Terms of Use, these Terms of Use do not grant you any other right
          or license in or under any patent, trademark, copyright, or other
          intellectual property or proprietary right. We may terminate or
          suspend this license at any time for any reason in our sole and
          absolute discretion. Any use that may suggest a community of interest
          or business relationship other than that between independently owned
          and operated businesses is also strictly prohibited.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Purchases through MYSKP</strong>
        </p>
        <p>
          Certain features of MYSKP may now or may in the future permit you to
          make purchases. You may only make purchases through MYSKP if you are
          over the age of legal majority in your jurisdiction of residence.
          Purchases will only be shipped to a valid mailing address in the
          United States (as determined by SKP in its sole and absolute
          discretion). However, please note that we may not be able to ship to
          all valid addresses and, in such circumstances, we reserve the right
          in our sole and absolute discretion to cancel your purchase
          transaction (“<strong>Order</strong>”). In the event we are not able
          to ship to the shipping address you provide, we will notify you, your
          Order will be cancelled, and you will receive a refund in respect of
          your Order (unless you are able to provide an alternate eligible
          shipping address). We further reserve the right not to offer expedited
          or other forms of shipping. Unless otherwise indicated, all dollar
          amounts are in United States Dollars.
        </p>
        <p>
          All Orders made through MYSKP are subject to these Additional Terms,
          as well as any other applicable terms and conditions outlined on MYSKP
          relating to the Order. Pricing and other terms and conditions relating
          to the purchase, return, refund, or delivery of your Order may be
          changed at any time without notice. Prices may differ from those for
          purchases made through other channels. You have a legal obligation to
          pay for any Orders indicated to be made by you. By completing an Order
          through MYSKP, you are agreeing to pay, in full, the prices and all
          applicable taxes and specified shipping and handling and other fees in
          relation to your Order, either by credit card or other permitted
          payment method.
        </p>
        <p>
          SKP reserves the right, in its sole and absolute discretion, to change
          the permitted methods of payment, including without limitation, the
          credit cards and/or other types of payment options we are able to
          accept, at any time. If complete payment for your Order is not
          received and verified by us, your Order will not be processed. If you
          do not complete or improperly complete your Order it may not be
          accepted or acknowledged.
        </p>
        <p>
          In order to complete an Order through MYSKP, you may be required to
          provide certain additional information that is required to process
          your Order. For example, you will be required to provide valid payment
          information (e.g. a valid credit card number and expiration date) to
          facilitate payment of your Order.
        </p>
        <p>
          You will be billed for your Order at the time your Order is placed.
          You will be responsible for all applicable taxes related to your
          Order. Applicable taxes will be charged at the time you are billed.
          Applicable sales tax will also be applied to the shipping and
          handling, return shipping and gift packaging or other charges. Taxes
          may depend on delivery location.
        </p>
        <p>
          Without limiting the generality of any other section of these
          Additional Terms, SKP reserves the right to limit or refuse any Order
          you place with us. Further, we reserve the right to verify the
          validity of all Orders and/or cancel any Order if we find evidence of
          fraud, tampering and/or any other violation of the terms and
          conditions of these Additional Terms, or our Terms of Use. We may, in
          our sole and absolute discretion, limit or cancel quantities purchased
          per person, per account or per Order. These restrictions may include
          Orders placed by or under the same account, by the same salon or
          business, using the same credit card, and/or Orders that use the same
          billing and/or shipping address. We also reserve the right, in our
          sole and absolute discretion, not to ship items ordered or purchased
          through MYSKP to certain addresses. In the event that we are unable to
          or choose not to ship an item, you will be notified accordingly and
          the amount for that item charged in relation to your Order will be
          reduced accordingly.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Communications on MSKP</strong>
        </p>
        <p>
          MYSKP allows SKP to send communications and notifications to users,
          and/or any particular class of users both through the MYSKP online
          portal and/or via email notifications. Certain features of MYSKP may
          permit certain classes of user to communicate with other users- both
          through the MYSKP online portal and/or via email notifications. Should
          you be permitted and choose to communicate with any other users, you
          must comply with all applicable laws in so doing, including without
          limitation all United States privacy laws. You must have any consents
          required under such laws, and must include in your messages all
          required content and disclosures, including without limitation any
          required unsubscribe mechanisms.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Indemnity</strong>
        </p>
        <p>
          You agree to defend, indemnify, and hold harmless SKP, and our
          affiliates, and the officers, directors, employees, agents and
          representatives of each of them, from and against any claims, actions,
          demands, losses, liabilities, damages, costs, suits, actions,
          penalties and expenses arising out of or relating, directly or
          indirectly, to: (i) your access to and/or use of a MYSKP, the
          services, and/or any component thereof, (ii) your violation of any of
          the terms and conditions of this agreement; (iii) your use of the
          Advertising Materials, including any Offers you choose to make in
          association therewith, and/or (iv) the infringement by you, or any
          third party using your account, of any intellectual property or other
          right of any person or entity, including without limitation if you
          violate the terms of any licence associated with the Advertising
          Materials. You agree that SKP may assume the exclusive defense and
          control of any matter for which you are required to indemnify SKP and
          you agree to cooperate, at your cost, with our defense of these
          claims. You agree not to settle any such matter without the prior
          written consent of SKP.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Electronic Notification</strong>
        </p>
        <p>
          To the extent that we contact you, you agree that we may do so via any
          electronic means, including but not limited to communications posted
          on MYSKP, Messenger application notifications or electronic mail.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>No Agency Relationship</strong>
        </p>
        <p>
          You agree that no joint venture, partnership, agency or employment
          relationship exists between you and SKP as a result of these Terms or
          Use or use of MYSKP and access to the services.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Termination</strong>
        </p>
        <p>
          If you breach any provision of these Additional Terms of Use (as
          determined by SKP in its sole and absolute discretion), then you may
          no longer use MYSKP, the services, or any component thereof. We may,
          in our sole and absolute discretion, change, suspend or terminate,
          temporarily or permanently, MYSKP, the services, or any component
          thereof or any of its features at any time, for any reason, without
          any notice or liability to you or any other entity. If these Terms of
          Use or your permission to use MYSKP is terminated by us for any
          reason, the agreement formed by your acceptance of these Terms of Use
          will nevertheless continue to apply and be binding upon you in respect
          of your prior use of MYSKP and anything relating to or arising from
          such use. If you are dissatisfied with MYSKP, the services, or any
          component thereof, then your sole and exclusive remedy is to
          discontinue using them.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>
            Collection, Use and Disclosure of Information by MYSKP.
          </strong>
        </p>
        <p>
          Without limiting the terms of our privacy statement{' '}
          <a
            href="https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank"
            style={{ textDecoration: 'underline' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.henkel-northamerica.com/privacy-statement-na?view=content-blank
          </a>
          , which applies to MYSKP in addition to this section, when you use
          MYSKP, you agree we may collect, use, and disclose your information as
          described in this section.
        </p>
      </li>
    </ol>
    <ol type="A" style={{ paddingLeft: '16px' }}>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Information Collection on MYKP.</strong> SKP collects the
          following identifiable information through MYSKP:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>Your first and last name;</p>
          </li>
          <li>
            <p>Your Sales Rep ID (if applicable);</p>
          </li>
          <li>
            <p>Your Sales Rep Email Address (if applicable);</p>
          </li>
          <li>
            <p>Your salon name and salon owner;</p>
          </li>
          <li>
            <p>
              Any contact information you provide including, but not limited to,
              your phone number and address;
            </p>
          </li>
          <li>
            <p>
              Your email address as well as any contact information provided at
              the time of registering for an account on MYSKP;
            </p>
          </li>
          <li>
            <p>
              Geo-location data, should this data allow for your identification;
              and
            </p>
          </li>
          <li>
            <p>
              Any other identifiable personal information you choose to provide
              to us when using MYSKP
            </p>
          </li>
        </ul>
        <br />
        <p>
          For users who are distributors, MYSKP collects information you provide
          as follows:
        </p>
        <p>
          <strong>Sales Table</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- TransactionID</p>
          </li>
          <li>
            <p>- TransactionDate</p>
          </li>
          <li>
            <p>- SalonTaxID OR - SalonID</p>
          </li>
          <li>
            <p>- SalesRepID</p>
          </li>
          <li>
            <p>- Sku/ProductID</p>
          </li>
          <li>
            <p>- Qty</p>
          </li>
          <li>
            <p>- TotalCost</p>
          </li>
          <li>
            <p>- Product Name</p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Product Table</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- Sku/ProductID</p>
          </li>
          <li>
            <p>- ProductBrand</p>
          </li>
          <li>
            <p>- ProductName</p>
          </li>
          <li>
            <p>- ProductDescription</p>
          </li>
          <li>
            <p>- ProductCategory</p>
          </li>
          <li>
            <p>- ProductSubCategory</p>
          </li>
          <li>
            <p>- ProductPrice</p>
          </li>
          <li>
            <p>- SKP IDH#</p>
          </li>
          <li>
            <p>- Wholesale Price</p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Salon Table</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- SalonID</p>
          </li>
          <li>
            <p>- SalonTaxID</p>
          </li>
          <li>
            <p>- SalonName</p>
          </li>
          <li>
            <p>- SalonAddressStreet1</p>
          </li>
          <li>
            <p>- SalonAddressStreet2</p>
          </li>
          <li>
            <p>- SalonAddressCity</p>
          </li>
          <li>
            <p>- SalonAddressPostal</p>
          </li>
          <li>
            <p>- SalonAddressState</p>
          </li>
          <li>
            <p>- SalonAddressCountry</p>
          </li>
          <li>
            <p>- SalonRegion</p>
          </li>
          <li>
            <p>- SalonSubRegion</p>
          </li>
          <li>
            <p>- Salon phone number</p>
          </li>
          <li>
            <p>- Salon contact information</p>
          </li>
        </ul>
        <br />
        <p>
          <strong>Sales Rep Table</strong>
        </p>
        <ul style={{ paddingLeft: '16px' }}>
          <li>
            <p>- SalesRepID</p>
          </li>
          <li>
            <p>- SalesRepName</p>
          </li>
          <li>
            <p>- SalesRepEmailAddress</p>
          </li>
          <li>
            <p>- SalesRepRegion</p>
          </li>
          <li>
            <p>- SalesRepSubRegion</p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Use of Information by MYSKP</strong>
        </p>
        <p>
          The personal information and any other information obtained from you
          through your use of MYSKP may be used by SKP and its service providers
          for analytical purposes, including through assessing and evaluating
          your usage of MYSKP (including the modules and applications of MYSKP
          you use and how often and for how long you use them and your click
          stream), and for business evaluation purposes and future performance
          forecasting and modeling. In addition to the foregoing, SKP may use
          such information as is reasonably necessary for the following:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>Managing your account on MYSKP;</p>
          </li>
          <li>
            <p>
              Providing you with the services and features available through
              MYSKP including preparing and providing reports on your sales,
              product levels and purchasing history, and those of the salons in
              your supply chain;
            </p>
          </li>
          <li>
            <p>
              Facilitate any purchase you choose to make using a Website,
              including facilitating payment for your purchase;
            </p>
          </li>
          <li>
            <p>
              Notify you when an order you have made using a Website is ready
              for pick-up or delivery;
            </p>
          </li>
          <li>
            <p>
              To administer any loyalty, incentive, or rewards program we may
              offer and choose to allow access to through MYSKP, including
              allowing you to review your balance, redemption, and any rewards
              that you have received, in accordance with the terms of such
              program;
            </p>
          </li>
          <li>
            <p>
              To create a publicly accessible listing of Salons and outer
              businesses, that carry SKP products, including business name and
              contact information;
            </p>
          </li>
          <li>
            <p>
              To allow you to create a calendar of your scheduled events,
              appointments, and activities; and
            </p>
          </li>
          <li>
            <p>
              If you choose to provide you location information, to help enable
              you to map and produce routes for your planned activities, such as
              planed visits to salons.
            </p>
          </li>
        </ul>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Disclosure of Information by MYSKP</strong>
        </p>
        <p>
          Please note that SKP reserves the right to disclose your personal
          information, as is reasonably necessary, to a third party without your
          prior consent in the following events:
        </p>
        <ul style={{ paddingLeft: '16px', listStyle: 'disc' }}>
          <li>
            <p>
              If your conduct on MYSKP breaches the Terms of Use and the
              disclosure of such information would allow SKP to protect their
              legal rights and/or avail themselves of any remedies that may be
              available to ether of them at law;
            </p>
          </li>
          <li>
            <p>
              Should SKP deem in good faith that such disclosure is necessary to
              identify and/or contact any person in view of or undertake legal
              actions against a person to protect or enforce the rights or
              properties of SKP or those of other users; or
            </p>
          </li>
        </ul>
        <br />
        <p>
          In the event that SKP deems in good faith that the law requires or
          permits such disclosure, including sharing identifiable personal
          information with other companies and organizations for the purpose of
          preventing fraud, or in order to comply with any legal or regulatory
          requirements.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Technical Data</strong>
        </p>
        <p>
          You agree that SKP <strong>and/</strong>or its service providers may
          collect and use technical data and related information, including but
          not limited to technical information about your device, system and
          application software, and peripherals, to facilitate the provision of
          software updates, product support and other services to you (if any)
          related to MYSKP. SKP or Zapplogix may use and disclose this
          information to third-parties, as long as it is in a form that does not
          personally identify you, to improve its products or to provide
          services or technologies to you.
        </p>
      </li>
      <li style={{ marginBottom: '16px' }}>
        <p>
          <strong>Cookies</strong>
        </p>
        <p>
          We may use a feature on your device or browser called a “cookie”
          and/or other similar devices. Cookies are small files that your
          browser places on your device’s hard drive. They are used for a
          variety of reasons, such as tracking click streams, optimization,
          marketing, and load balancing. We use a combination of session and
          persistent cookies to enable our log-in function, shopping carts,
          remember items you have added to your cart, allow you to create wish
          lists, checkout processing and to provide use with the ability to
          remember and improve your experience. We may use this information to
          determine your general geographic location to display the correct
          version of MYSKP. Information tracked through these mechanisms may
          include, but is not limited to: (i) your IP address; (ii) the type of
          browser and operating system being used; and (iii) the pages of the
          site or application a user visits. Your browser gives you the option
          to reject cookies. However, setting your browser to reject cookies
          generally hinders the browser’s performance and will adversely affect
          your experience while using MYSKP, and certain features may not work.
          To be able to make a purchase using MYSKP, the following cookies are
          necessary and would need to be accepted: ‘siteId’, ‘id_token.*’,
          ‘gId’, ‘locale’.
        </p>
      </li>
    </ol>
  </div>
);

export default TermsAdditional;



// WEBPACK FOOTER //
// ./src/components/_Site/US/TermsAdditional.js